var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { XFormInputContainer } from './XFormInputContainer';
export function XFormInputNumber(input) {
    var value = input.value;
    function handleChange(nextValue) {
        var _a;
        (_a = input.onChange) === null || _a === void 0 ? void 0 : _a.call(input, nextValue);
    }
    return (React.createElement(XFormInputContainer, __assign({}, input),
        React.createElement("input", __assign({}, input, { type: 'number', value: String(value !== null && value !== void 0 ? value : ''), onChange: function (event) {
                handleChange(event.target.value);
            } }))));
}
